import { Injectable, inject } from '@angular/core';
import { OrigamiUrls } from '@app/origami-api/constants/origami-urls';
import { SessionService } from '@app/session/session.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrigamiResponse } from '@app/origami-api/services/base/service.base';
import { OrigamiResponseWithAuthUrl } from '@app/origami-api/services/e-signature.service';

export interface Image {
  Url: string;
  Name: string;
  Size?: number;
  AuthKey?: string;
  LastModified?: string;
  PreviewUrl?: string | null;
}
@Injectable({
  providedIn: 'root',
})
export class InsertImageModalService {
  private sessionService = inject(SessionService);
  private httpClient = inject(HttpClient);

  loadImages(): Observable<OrigamiResponseWithAuthUrl<Image[]>> {
    const requestParams = {
      siteId: this.sessionService.currentRoomId.toString(),
      fileMask: '*.jpg,*.jpeg,*.gif,*.png,*.bmp,*.gif',
    };

    return this.httpClient.post<OrigamiResponseWithAuthUrl<Image[]>>(OrigamiUrls.getSiteFilesURL, requestParams, {
      withCredentials: true,
    });
  }

  deleteImage(item: Image): Observable<OrigamiResponseWithAuthUrl<boolean>> {
    const params = {
      siteId: this.sessionService.currentRoomId.toString(),
      fileName: item.Name,
    };

    return this.httpClient.post<OrigamiResponseWithAuthUrl<boolean>>(OrigamiUrls.deleteSiteFileURL, params, {
      withCredentials: true,
    });
  }

  uploadSiteImage(file: File): Observable<OrigamiResponse<string>> {
    const url = OrigamiUrls.imageUploadUrl.replace(/{siteId}/, `${this.sessionService.currentRoomId}`);
    const formData = new FormData();
    formData.append('files', file);
    return this.httpClient.post<OrigamiResponse<string>>(url, formData, { withCredentials: true });
  }
}
